<template>
  <div class="login-layout">
    <div class="login-layout__header">
      <auth-header-block>
        <default-button
          @click.stop="logoutUser">
          {{ $t('main.logout') }}
        </default-button>
      </auth-header-block>
    </div>
    <div class="login-layout__main">
      <div class="login-layout__main-inner">
        <h4>{{ $t('main.welcome') }}</h4>
        <gray-text class="mt-10">
          {{ $t('auth.please_verify_your_email_to_proceed') }}
        </gray-text>
        <hr class="my-20"/>
        <gray-text class="mt-10">
          {{ $t('auth.didnt_receive_verification_mail') }}
        </gray-text>
        <info-block
          v-if="response_message"
          :success="!response_error"
          :error="response_error"
          class="mt-15">
          {{ response_message }}
        </info-block>
        <div class="d-flex mt-20">
          <default-button
            class="w-100"
            @click="sendVerification">
            {{ $t('auth.send_verification_again') }}
          </default-button>
        </div>

      </div>
    </div>
    <loader v-if="loading"/>
  </div>
</template>

<script>

import GrayText from "../../small_components/GrayText.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import InfoBlock from "../../small_components/InfoBlock.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import Loader from "../../small_components/Loader.vue";
import {mapActions, mapGetters} from "vuex";
import user_mixin from "../../../mixins/user_mixin";
import AuthHeaderBlock from "../../parts/AuthHeaderBlock.vue";
import {axiosAuth} from "../../../helpers/axios_requests";
import {GO_TO_DASHBOARD, GO_TO_VERIFY_EMAIL} from "../../../router";
import {GET_QUERY_OBJECT} from "../../../helpers/url_helper";
import {UNLINK_VARIABLE} from "../../../helpers/variable_helpers";
import routes_mixin from "../../../mixins/routes_mixin";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR} from "../../../store/modules/notifiocation";

export default {
  name: 'VerifyEmailLayout',
  mixins: [user_mixin, routes_mixin],
  components: {
    AuthHeaderBlock,
    Loader,
    DefaultInput,
    InfoBlock,
    DefaultButton,
    GrayText,
  },
  ...mapGetters([
    'getUserMailVerified'
  ]),
  data() {
    return {
      response_message: '',
      response_error: false,
      loading: false,
      verification_data: null
    }
  },
  computed: {
    ...mapGetters([
      'getUserMailVerified'
    ]),
    verification_hash() {
      return this.verification_data?.hash
    },
    verification_id() {
      return this.verification_data?.id
    },
    verification_valid() {
      return this.verification_hash && this.verification_id
    }
  },
  created() {
    if (!location.search) return
    this.$set(this, 'verification_data', GET_QUERY_OBJECT(location.search))
    if (!this.verification_valid) return;
    this.verifyMyEmail()
  },
  methods: {
    ...mapActions([
      'actionSetUser',
      'actionPushNotification'
    ]),
    sendVerification() {
      this.loading = true
      this.response_message = ''
      this.response_error = false
      axiosAuth.sendVerification()
        .then(({data}) => {
          this.response_message = data.message
        })
        .catch(e => {
          console.log(e);
          this.response_message = e.response?.data.error || e.response?.data.message
          this.response_error = true
        }).finally(() => {
          this.loading = false
        })
    },
    verifyMyEmail() {
      if (!this.verification_valid) return
      this.loading = true
      this.response_message = ''
      this.response_error = false
      axiosAuth.verifyMyEmail({
        id: this.verification_id,
        hash: this.verification_hash
      })
        .then(({data}) => {
          if (data.errors) {
            let message = FORMAT_ERROR_MESSAGE(data.errors)
            this.actionPushNotification(
                {message: message, status: STATUS_ERROR}
            )
            return;
          }
          this.response_message = 'Success'
          this.actionSetUser(data.user)
          if (!this.getUserMailVerified) return
          GO_TO_DASHBOARD()
        })
        .catch(e => {
          console.log(e);
          this.response_message = e.response?.data.error || e.response?.data.message
          this.response_error = true

          // remove hash from parameters
          this.$router.replace(location.pathname)
        }).finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
